import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // State'i güncelleyerek bir sonraki render'da fallback UI'ı göster
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Hata detaylarını kaydet
    this.setState({
      error: error,
      errorInfo: errorInfo
    });

    // Hata raporlama servisi burada çağrılabilir
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    
    // ChunkLoadError için özel handling
    if (error.name === 'ChunkLoadError' || error.message.includes('Loading chunk')) {
      console.warn('ChunkLoadError detected - likely due to new deployment. Attempting reload...');
      // Kısa bir gecikme sonrası otomatik yenile
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  }

  render() {
    if (this.state.hasError) {
      // ChunkLoadError için özel mesaj
      const isChunkError = this.state.error && (
        this.state.error.name === 'ChunkLoadError' || 
        this.state.error.message.includes('Loading chunk')
      );
      
      // Fallback UI - özelleştirilebilir
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
            <div className="text-6xl mb-4">🐎</div>
            <h1 className="text-2xl font-bold text-gray-800 mb-4">
              {isChunkError ? 'Loading new update...' : 'Sorry, something went wrong'}
            </h1>
            <p className="text-gray-600 mb-6">
              {isChunkError ?
                'The site has been updated. The page will now refresh automatically...' :
                'An unexpected error occurred on the NYC Royal Carriage website. Please refresh the page or try again later.'
              }
            </p>
            {isChunkError && (
              <div className="mb-6">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500 mx-auto"></div>
              </div>
            )}
            {!isChunkError && (
              <div className="space-y-3">
                <button
                  onClick={() => window.location.reload()}
                  className="w-full bg-brand-500 hover:bg-brand-600 text-black font-bold py-3 px-6 rounded-lg transition-colors"
                >
                  Refresh Page
                </button>
                <button
                  onClick={() => window.location.href = '/'}
                  className="w-full bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-3 px-6 rounded-lg transition-colors"
                >
                  Return to Home
                </button>
              </div>
            )}
            
            {/* Show error details in development environment */}
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details className="mt-6 text-left">
                <summary className="cursor-pointer text-sm text-neutral-600 hover:text-gray-700">
                  Error Details (Developer Mode)
                </summary>
                <div className="mt-2 p-4 bg-red-50 border border-red-200 rounded text-xs font-mono text-red-700 overflow-auto max-h-40">
                  <div className="font-bold mb-2">Error:</div>
                  <div className="mb-4">{this.state.error && this.state.error.toString()}</div>
                  <div className="font-bold mb-2">Stack Trace:</div>
                  <div className="whitespace-pre-wrap">{this.state.errorInfo.componentStack}</div>
                </div>
              </details>
            )}
          </div>
        </div>
      );
    }

    // Hata yoksa normal olarak children'ı render et
    return this.props.children;
  }
}

export default ErrorBoundary;